import React from 'react'
import { Cursor, useTypewriter } from 'react-simple-typewriter'
import { FaGlobe, FaLine, FaLinkedinIn, FaReact } from 'react-icons/fa'
import { SiTailwindcss, SiFigma, SiNextdotjs } from 'react-icons/si'
import { FaMoneyCheckDollar, FaMobileScreenButton } from "react-icons/fa6";
import { IoPodium } from "react-icons/io5";
import { FaSwift } from "react-icons/fa";
import { IoBook } from "react-icons/io5";

import { FaAddressBook } from "react-icons/fa";
import { IoStorefrontSharp } from "react-icons/io5";

import { GiArtificialIntelligence } from "react-icons/gi";
import { FaMedium } from "react-icons/fa";

import { SiGooglemarketingplatform } from "react-icons/si";
import { GiPublicSpeaker } from "react-icons/gi";


import { SiLeaderprice } from "react-icons/si";
import { IoDocumentAttach } from "react-icons/io5";







const LeftBanner = () => {
    const [text] = useTypewriter({
        words: ["Business Analyst", "Data Analyst", "Developer"],
        loop: true,
        typeSpeed: 20,
        deleteSpeed: 10,
        delaySpeed: 2000
    })
  return (
            <div className='w-1/2 flex flex-col gap-20'>
            <div className='flex flex-col gap-3'>
                <h4>WELCOME TO MY WORLD</h4>
                <h1 className='text-6xl font-bold text-white'>Hi, I'm {" "}
                    <span className='text-designColor capitalize'>Saktawat</span>
                </h1>
                <h2 className='text-4xl font-bold text-white'>
                    a <span>{text}</span>
                    <Cursor
                        cursorBlinking = "false"
                        cursorStyle= "|"
                        cursorColor='#ff014f'
                    />
                    
      
                </h2>
                <p className='text-base font-bodyFont leading-6 tracking-wide'>
                I am a Computer Engineering student at Chulalongkorn University with a passion for technology, innovation, and business. 
                Attending business summits with my father sparked my interest in strategy, leading to award-winning tech projects. As the owner of Chiang Mai Street Band Store (Bondst.cnx), I’ve honed skills in marketing and analytics. 
                I aim to merge technology and business to create impactful solutions.
                </p>
            </div>
            <div className='flex justify-between gap-9'>
            <div className='flex flex-col gap-5'>
                <div>
                    <h2 className='text-base uppercase font-titleFont mb-4'>
                        Find me in
                    </h2>
                    <div className='flex gap-4'>
                        <a href="https://medium.com/@nicesaktawat/building-a-credit-risk-prediction-model-to-reduce-loan-defaults-in-thailand-85fc5ac8c561" target="_blank" rel="noopener noreferrer">
                            <span className='bannerIcon'>
                                <FaMedium />
                            </span>
                        </a>
                        <a href="https://www.instagram.com/bondst.cnx?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" target="_blank" rel="noopener noreferrer">
                            <span className='bannerIcon'>
                                <IoStorefrontSharp />
                            </span>
                        </a>
                        <a href="https://www.linkedin.com/in/saktawat-pairachsaranon-7b79a329a/" target="_blank" rel="noopener noreferrer">
                            <span className='bannerIcon'>
                                <FaLinkedinIn/>
                            </span>
                        </a>
                        <a href="https://line.me/ti/p/AdInd2cQV-" target="_blank" rel="noopener noreferrer">
                            <span className='bannerIcon'>
                                <FaLine/>
                            </span>
                        </a>
                    </div>
                </div>

                <div>
                    
                        <h2 className='text-base uppercase font-titleFont mb-4'>
                            My Resume & Reference
                        </h2>
                    <div className='flex gap-4'>
                        <a href="https://drive.google.com/file/d/18kpNrf9qwADg4Xtc__YDXx9jo9ZmAVW6/view" target="_blank" rel="noopener noreferrer">
                            <span className='bannerIcon'>
                                <FaAddressBook/>
                            </span>
                        </a>
                        <a href="https://drive.google.com/file/d/12iDmu4IoqvQQIZyz39pOCUy4scvSopsI/view?usp=sharing" target="_blank" rel="noopener noreferrer">
                            <span className='bannerIcon'>
                                <IoBook/>
                            </span>
                        </a>
                    </div>
                </div>

            </div>
            <div>
            <h2 className="text-base uppercase font-titleFont mb-4">
            BEST SKILL ON
            </h2>
            <div className='flex flex-col gap-5'>
                <div className="flex gap-4">
                    <span className="bannerIcon" title="React js" style={{ position: 'relative', zIndex: 10 }}>
                        <FaReact />
                    </span>
                    <span className="bannerIcon" title="Next js" >
                    <SiNextdotjs />
                    </span>
                    <span className="bannerIcon" title="Tailwind.css" >
                    <SiTailwindcss />
                    </span>
                    <span className="bannerIcon" title="Figma" >
                    <SiFigma />
                    </span>
                </div> 
                <div className="flex gap-4">
                    <span className="bannerIcon" title="Business" >
                    <FaMoneyCheckDollar />
                    </span>
                    <span className="bannerIcon" title="Artificial Intelligence" >
                    <GiArtificialIntelligence />
                    </span>
                    <span className="bannerIcon" title="Business Analysis" >
                    <IoPodium />
                    </span>
                    <span className="bannerIcon" title="Swift UI" >
                    <FaSwift />
                    </span>
                </div> 
                <div className="flex gap-4">
                    <span className="bannerIcon" title="Marketing" >
                    <SiGooglemarketingplatform />
                    </span>
                    <span className="bannerIcon" title="Presentation" >
                    <GiPublicSpeaker />
                    </span>
                    <span className="bannerIcon" title="Leadership" >
                    <SiLeaderprice />
                    </span>
                    <span className="bannerIcon" title="Documentation" >
                    <IoDocumentAttach />
                    </span>
                </div> 
            </div>
            </div>
        </div>
        </div>
  )
}

export default LeftBanner